import React from 'react';
import Dialog from '../BuildingBlocks/Dialogs/DialogStyleOne/Dialog';
import AddProductForm from './AddProductForm';

export default function AddProductDialog(props) {
  const {
    open,
    handleClose,
    addProductToState,
    selectedProduct = null,
    setProducts,
    products,
  } = props;

  return (
    <Dialog
      open={open}
      title={selectedProduct ? 'Edit a product' : 'Add a product'}
      content={
        <AddProductForm
          handleClose={handleClose}
          addProductToState={addProductToState}
          selectedProduct={selectedProduct}
          setProducts={setProducts}
          products={products}
        />
      }
    />
  );
}
